var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { Progress } from './types'; //
// Async Data "constructors"
//

export var newInit = function newInit() {
  return {
    progress: Progress.Init
  };
};
export var newInProgress = function newInProgress() {
  return {
    progress: Progress.InProgress
  };
};
export var newSuccess = function newSuccess(payload, invalidated) {
  return {
    invalidated: invalidated != null ? invalidated : false,
    payload: payload,
    progress: Progress.Success
  };
};
export var newError = function newError(errorObj) {
  return {
    error: errorObj,
    progress: Progress.Error
  };
}; //
// Async Data state checkers
//

export var isInit = function isInit(asyncData) {
  return asyncData.progress === Progress.Init;
};
export var isInProgress = function isInProgress(asyncData) {
  return asyncData.progress === Progress.InProgress;
};
export var isSuccess = function isSuccess(asyncData) {
  return asyncData.progress === Progress.Success;
};
export var isValidSuccess = function isValidSuccess(asyncData) {
  return isSuccess(asyncData) && !asyncData.invalidated;
};
export var isInvalidated = function isInvalidated(asyncData) {
  return isSuccess(asyncData) && asyncData.invalidated === true;
};
export var isInProgressOrInvalidated = function isInProgressOrInvalidated(asyncData) {
  return isInProgress(asyncData) || isInvalidated(asyncData);
};
export var isError = function isError(asyncData) {
  return asyncData.progress === Progress.Error;
};
export var isAnyInit = function isAnyInit() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.some(function (asyncData) {
    return isInit(asyncData);
  });
};
export var isAnyInProgress = function isAnyInProgress() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.some(function (asyncData) {
    return isInProgress(asyncData);
  });
};
export var isAnySuccess = function isAnySuccess() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.some(function (asyncData) {
    return isSuccess(asyncData);
  });
};
export var isAnyValidSuccess = function isAnyValidSuccess() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.some(function (asyncData) {
    return isValidSuccess(asyncData);
  });
};
export var isAnyInvalidated = function isAnyInvalidated() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.some(function (asyncData) {
    return isInvalidated(asyncData);
  });
};
export var isAnyInProgressOrInvalidated = function isAnyInProgressOrInvalidated() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.some(function (asyncData) {
    return isInProgressOrInvalidated(asyncData);
  });
};
export var isAnyError = function isAnyError() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.some(function (asyncData) {
    return isError(asyncData);
  });
}; //
// Async Data transformations
//

export var getPayload = function getPayload(origin) {
  return isSuccess(origin) ? origin.payload : undefined;
};
export var getError = function getError(origin) {
  return isError(origin) ? origin.error : undefined;
};
export var setInProgressOrInvalidated = function setInProgressOrInvalidated(origin) {
  return isSuccess(origin) ? __assign({}, origin, {
    invalidated: true
  }) : newInProgress();
};
export var map = function map(origin, mapper, invalidated) {
  return isSuccess(origin) ? newSuccess(mapper(origin.payload), invalidated !== undefined ? invalidated : origin.invalidated) : origin;
}; //
// Higher level helpers
//

export var render = function render(origin, _render) {
  switch (origin.progress) {
    case Progress.Init:
      return _render.init ? _render.init() : null;

    case Progress.InProgress:
      return _render.inProgress ? _render.inProgress() : null;

    case Progress.Success:
      return _render.success ? _render.success(origin.payload, origin.invalidated) : null;

    case Progress.Error:
      return _render.error ? _render.error(origin.error) : null;
  }
};
export function task(asyncFunction, callback, _a) {
  var _b = _a === void 0 ? {} : _a,
      currentAsync = _b.currentAsync,
      onChange = _b.onChange,
      onSuccess = _b.onSuccess,
      onError = _b.onError;

  return __awaiter(this, void 0, void 0, function () {
    var result, successAsync, error_1, errorAsync;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          callback(currentAsync ? setInProgressOrInvalidated(currentAsync) : newInProgress());
          onChange && onChange();
          _c.label = 1;

        case 1:
          _c.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , asyncFunction()];

        case 2:
          result = _c.sent();
          successAsync = newSuccess(result);
          callback(successAsync);
          onChange && onChange();
          onSuccess && onSuccess(result);
          return [2
          /*return*/
          , successAsync];

        case 3:
          error_1 = _c.sent();
          errorAsync = newError(error_1);
          callback(errorAsync);
          onChange && onChange();
          onError && onError(error_1);
          return [2
          /*return*/
          , errorAsync];

        case 4:
          return [2
          /*return*/
          ];
      }
    });
  });
}